import React, {lazy} from 'react';

import {resolveBackground} from '#core/utils/color-utils.js';
import {ensureHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import SCHEMA from './custom-page.schema.yaml';
import PALETTE_SCHEMA from './custom-page.palette-schema.yaml';

const CustomPage = lazy(() => import('./custom-page.jsx'));

class CustomPageFeature extends AbstractVisualFeature {
    get name() {
        return 'Custom page';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    afterMojitoConfigBuild(mojitoConfig) {
        const RoutingView = ensureHierarchy(mojitoConfig, 'services.configurations.RoutingView');
        RoutingView.customRoutes = RoutingView.customRoutes || [];
        RoutingView.customRoutes.push({
            path: this.config.path,
            element: <CustomPage customHtml={this.config.customHtml} scriptUrl={this.config.scriptUrl} />,
        });

        return super.afterMojitoConfigBuild(mojitoConfig);
    }

    getVisualConfig(PALETTE) {
        return {
            CustomPage: {
                primaryContentContainer: {
                    style: {
                        ...resolveBackground(PALETTE.MAIN_CONTAINER_BG),
                    },
                },
            },
        };
    }
}

export const customPageFeature = new CustomPageFeature(allVisuals);
